<template>
  <div>
    <van-row class="orderAndCoupon">
      <van-col :span="12" class="order" @click="goOrder">
        <van-icon :name="orderMine" size="2rem" class="f-l-l m-t-05" />
        <div class="f-l-l p-l-05">
          <p class=" orderTitle">订单</p>
          <p><span id="orderNum">{{order}}</span><span id="orderText">笔待支付</span></p>
        </div>
      </van-col>
      <van-col :span="12" @click="goCoupon"  class="text-c">
        <van-icon :name="couponMine" size="2rem" class="f-l-l m-t-05 m-l-08" />
        <div class="f-l-l p-l-05">
          <p class=" orderTitle">优惠卷</p>
          <p><span id="orderNum">{{coupo}}</span><span id="orderText">张可用</span></p>
        </div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      orderMine:require('@/assets/imgs/mine/order.png'),
      couponMine:require('@/assets/imgs/mine/coup.png'),
      order:0,
      coupo:0
    }
  },
  created(){
    this.mineHead()
  },
  methods:{
    goCoupon(){
      this.$router.push('/coupon')
    },
    goOrder(){
      this.$router.push('/UnpaidOrder')
    },
    mineHead(){
      if(!this.getTokenType()) return false
      this.Api({
        url:"api/mine/mineHead",
        method:"GET"
      }).then(res => {
        this.order = res.data[0]
        this.coupo = res.data[1]
      })
    }
  },
  watch:{
    $route:{
      handler(val){
        if(val.path == "/mine"){
          this.mineHead()
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.orderAndCoupon {
  padding: 0.5rem 0.8rem;
  background-color: white;
  border-radius: 0.3rem;
}
.order {
  border-right: 1px solid #F2F2F2;
}
.orderTitle {
  color:#292E35;
  font-size: 0.8rem;
}
#orderNum {
  color: #F08040;
  font-size: 0.7rem;
}
#orderText {
  color: #657081;
  font-size: 0.7rem;
}
// .orderIcon {
//   width: 1.74rem;
//   height: 1.8rem;
// }
</style>